@if (form && control) {
  <div [formGroup]="form">
    <app-material-input-checkbox
      [require]="require"
      [formControlName]="field_name">
      <ng-content></ng-content>
    </app-material-input-checkbox>
  </div>
}
